import { render } from "./GeneralBenchmarkDetail.vue?vue&type=template&id=6d4e0463&scoped=true"
import script from "./GeneralBenchmarkDetail.vue?vue&type=script&lang=js"
export * from "./GeneralBenchmarkDetail.vue?vue&type=script&lang=js"

import "./GeneralBenchmarkDetail.vue?vue&type=style&index=0&id=6d4e0463&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4e0463"]])

export default __exports__